<p-panel>
  <div class="d-flex align-content-center justify-content-left">

    <div>
      @if (flag === 'edit') {
        <h4>{{ headerTitleWhenEdit }}</h4>
      } @else {
        <h4>{{ headerTitleWhenNew }}</h4>
      }
    </div>

  </div>

  <div class="row">
    <app-reactive-form-builder
      #formbuilder
      (formChanges)="formChanges($event[0], $event[1])"
      (goBack)="goBack()"
      (afterSend)="undefined"
      [form]="form.formFields"
      [serverUrl]="''"
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [previousData]="getModel()"
      [request]="getType() === FormRequestTypes.EDIT ? fincasApi.sectoresPUT : fincasApi.sectoresPOST"
      [getRequest]="fincasApi.sectoresGET">
    </app-reactive-form-builder>
  </div>
</p-panel>